export default {
    variants: {
        info: (props) => ({
            ...(props?.theme?.textStyles?.bodyXsRegular || {}),
            bg: 'webTheme.backgroundDefault',
            p: '8px',
            maxW: '288px',
            borderRadius: '2px',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            color: 'webTypo.textPrimary',
            boxShadow: 'none'
        })
    }
}
